import clsx from 'clsx'
import styles from '../VehicleAllocationColumn.module.scss'
import DotsIcon from '../../../assets/dots.svg'
import { Allocation, AllocationChange } from '@/types/vehicleAllocation'
import { useVehicleAllocationStore } from '@/pages/VehicleAllocationController'

interface OverlayBonnetProps {
    allocation: Allocation
    allocationChange?: AllocationChange
    route: string
}

export const OverlayBonnet = ({ allocation, allocationChange, route }: OverlayBonnetProps) => {
    const { routeEditing } = useVehicleAllocationStore()
    const isEditing = routeEditing === route

    return (
        <div
            className={clsx(styles.bonnet, {
                [styles.editing]: isEditing,
            })}
        >
            <button className={styles.editManualButton} disabled={!isEditing}>
                {allocationChange ? allocationChange.fleetNumber : (allocation.bonnet ?? '-')}
            </button>

            {isEditing && (
                <div className={styles.trigger}>
                    <DotsIcon />
                </div>
            )}
        </div>
    )
}
